import { ROOT_URL } from 'envs/_current/config'
import _ from 'lodash'
import { documentSchema } from '../schema'
import base, {
  get,
  getLinkToDetailGenerator,
  getLinkToSettingGenerator,
  getLinkToShareGenerator,
  getType,
} from './base'
const getId = get('idname')
export const getLinkToDetail = getLinkToDetailGenerator({ getId, getType })
export const getLinkToSetting = getLinkToSettingGenerator({ getId, getType })
export const getLinkToShare = getLinkToShareGenerator({
  rootUrl: ROOT_URL,
  getType,
  getId,
})

export const getLinkToDocuments = (suffix = '') => {
  const root = '/docs'
  if (_.isEmpty(suffix)) {
    return root
  }
  return [root, suffix.trim()].filter((e) => !_.isEmpty(e)).join('/')
}

export const getLinkToDocument = (idname) => `/docs/${idname}`

export const getLinkToTopic = (id) => {
  if (_.isEmpty(id)) {
    return getLinkToDocuments()
  }
  return `/t/${id}`
}

export const getDefaultTopicURL = () => '/t/{idname}/home'

export default {
  ...base,
  getLinkToDetail,
  getLinkToSetting,
  getLinkToShare,
  getLinkToDocument,
  getLinkToDocuments,
  getLinkToTopic,
  getDefaultTopicURL,
  schema: documentSchema,
  getId,
}
